import React from 'react';

function TopBarSpacer() {
    return (
        <div className="w-full h-10 bg-blue-600" />
    );
}

export default TopBarSpacer;


